var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"colored-username",style:({
		color: _vm.color
	}),attrs:{"title":_vm.title},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.username)+" "),_c('RagequitIndicator',{attrs:{"percentage":_vm.ragequitPercentage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }